import React from "react";

import greenland from "../../assets/logo/greenland.jpg";
import soft from "../../assets/logo/soft.jpg";
import tracker from "../../assets/logo/Iconic-Trucker-logo-1.png";
import tours from "../../assets/logo/travel.jpg";
import transport from "../../assets/logo/transport.jpg";
import shikhon from "../../assets/logo/shikhon.jpg";
import digital from "../../assets/logo/digital.jpg";
import furniture from "../../assets/logo/furniture.jpg";
import motors from "../../assets/logo/motors.jpg";
import express from "../../assets/logo/express.jpg";
import holiday from "../../assets/logo/holidy.png";
import bdiconic from "../../assets/logo/BD_Iconic_preview.png";

const SisterConcerms = () => {
  const isMobile = window.innerWidth <= 768;
  return (
    <section
      style={{
        padding: isMobile ? "15px 8px" : "30px 0px",
        maxWidth: "1460px",
        margin: "0 auto",
      }}
      className="team"
    >
      <h2>OUR SISTER CONCERN</h2>
      <div className="team-members">
        <img src={greenland} alt="" />
        <img style={{ height: "95px" }} src={holiday} alt="" />
        <img src={soft} alt="" />
        <img src={tours} alt="" />
        <img src={shikhon} alt="" />
        <img src={furniture} alt="" />
        <img src={digital} alt="" />
        <img src={tracker} alt="" />
        <img src={transport} alt="" />
        <img src={motors} alt="" />
        <img src={express} alt="" />
        <img style={{ height: "95px" }} src={bdiconic} alt="" />
      </div>
    </section>
  );
};

export default SisterConcerms;
